import { RequestMessage } from '../Messaging/RequestMessage';

export const dismissOfflinePageMessageTag = 'DismissOfflinePageMessage';

/**
 * Request to show the offline page.
 */
export class DismissOfflinePageMessage extends RequestMessage {
  readonly tag: string = dismissOfflinePageMessageTag;
}
